import {ChangeEvent, FC, FormEvent, useState} from "react";
import {useNavigate} from "react-router-dom";
import {handleRTKQuery} from "../../../../helpers/utils/RtkQueryUtils";
import {OptionType} from "../../../../helpers/utils/StyleUtils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import InputField from "../../../../components/common/form/InputField";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import {Routes as AppRoutes} from "../../../../routes";
import {useCreateThirdPartyProviderDetailApiMutation} from "../thirdPartyProvider";
import Form from "../../../../components/common/form/Form";

const CreateThirdPartyProvider: FC = () => {
    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "Third Party Provider", url: "/third-party-providers"},
        {content: "Add Third Party Provider", url: ""},
    ]);

    const navigate = useNavigate();
    const [providerData, setProviderData] = useState<any>({});
    const [createApi, createApiResponse] = useCreateThirdPartyProviderDetailApiMutation(); // Defined mutation

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        let obj = {...providerData};

        const create = async () => {
            return await createApi(obj).unwrap();
        };

        await handleRTKQuery(create, (response: any) => {
             if (response?.success || response?.data?.success) {
                setProviderData({});
                navigate(AppRoutes.ThirdPartyProvider.path);
            }
        });

    };

    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null }) => {
        const {name, value} = "target" in e ? e.target : e;
        setProviderData({
            ...providerData,
            [name]: value,
        });
    };

    return (
        <>
            <div className="adduser_container px-4 py-2">
                <Breadcrumb crumbs={crumbs}/>
                <div className="flex justify-center mt-3">
                    <div className="bg-text-0 lg:w-4/6 sm:w-full p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                        <h3 className="text-xl font-semibold text-surface-0 pb-3 border-b border-surface-5">
                            Add Third Party Provider
                        </h3>

                        <Form onSubmit={handleSubmit} fields={<>
                            <div className="grid grid-cols-12 adduser_Wrapper">
                                <InputField
                                    name="name"
                                    label="Name"
                                    onChange={handleOnChange}
                                    value={providerData?.name || ""}
                                    type="text"
                                    placeholder="Enter Name..."
                                    required
                                />
                                <InputField
                                    name="website"
                                    label="Website"
                                    onChange={handleOnChange}
                                    value={providerData?.website || ""}
                                    type="text"
                                    placeholder="Enter Website..."
                                />
                            </div>

                            <div className="col-span-12 md:grid md:grid-cols-12 gap-3">
                                <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                </div>
                                <div className="relative col-span-9">
                                    <div className={"mt-4 flex"}>
                                        <ButtonTray
                                            buttons={[
                                                {
                                                    buttonProps: {
                                                        btnText: "Cancel",
                                                        onClick: () => navigate(AppRoutes.ThirdPartyProvider.path),
                                                        type: "cancel", // Changed from "close" to "button"
                                                    },
                                                    buttonType: "button",
                                                },
                                                {
                                                    buttonProps: {
                                                        btnText: "Submit",
                                                        type: "submit",
                                                        isLoading: createApiResponse.isLoading,
                                                    },
                                                    buttonType: "button",
                                                }
                                            ]}
                                            align="end"
                                            gap={2}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>}/>
                    </div>
                </div>
            </div>

        </>
    );
};

export default CreateThirdPartyProvider;
